import React from 'react';
import { Col, Row } from 'react-bootstrap';
import CampaignFeedback, { IFeedbackData } from './summary/components/CampaignFeedback';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import CardRightKPI from './kpis/CardRightKPI';
import { IMeasure } from '../../../../../model/measure/IMeasure';
import { AccessRightEnum } from '../../../../../enum/AccessRightEnum';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import CampaignClientPreview from './CampaignClientPreview';
import { useMediaQuery } from '@mui/material';
import { BootstrapBreakpoints } from '../../../../../enum/BootstrapBreakpoints';

interface FeedbackAndKpiCardProps {
    setTriggerSummaryData: (...args: any) => void;
    summaryData?: IMeasure;
    setFeedbackData: React.Dispatch<React.SetStateAction<IFeedbackData | undefined>>;
    feedbackData?: IFeedbackData;
}
const FeedbackAndKpiCard = ({
    summaryData,
    setTriggerSummaryData,
    setFeedbackData,
    feedbackData,
}: FeedbackAndKpiCardProps) => {
    const { accessRights } = useSelector((authState: IAllStates) => authState.auth.user);
    const hasAdditionalKpi = !!summaryData?.additionalKpi?.length;
    const defaultKpi = [
        {
            title: '',
            value: '',
            validtitle: { isValid: true, startValid: false },
            validvalue: { isValid: true, startValid: false },
        },
    ];
    const additionalKpi = hasAdditionalKpi ? summaryData?.additionalKpi : defaultKpi;
    const isMobile = useMediaQuery(`(max-width: ${BootstrapBreakpoints.LG}px)`);

    return (
        <CardLayout classCard="mb-3">
            {accessRights.includes(AccessRightEnum.CAN_SET_ADDITIONAL_KPI) ? (
                <Row>
                    <Col lg={8} className={`${isMobile ? 'border-bottom mb-2 pb-2' : 'border-right'}`}>
                        <CampaignFeedback setFeedbackData={setFeedbackData} feedbackData={feedbackData} />
                    </Col>
                    <Col lg={4}>
                        {accessRights.includes(AccessRightEnum.CAN_SET_ADDITIONAL_KPI) || hasAdditionalKpi ? (
                            <CardRightKPI setTriggerSummaryData={setTriggerSummaryData} additionalKpi={additionalKpi} />
                        ) : null}
                    </Col>
                </Row>
            ) : (
                <>
                    {/*Here is same logic, but only different view on client side*/}
                    <CampaignClientPreview feedbackData={feedbackData} additionalKpi={additionalKpi} />
                </>
            )}
        </CardLayout>
    );
};

export default React.memo(FeedbackAndKpiCard);
